export default "__VITE_ASSET__BWgheypL__"